import axios from "axios";

axios.defaults.baseURL = "https://cokmezinsaat.levelupcrm.com.tr/api/";
// axios.defaults.baseURL = "http://localhost:8080/";

const setAuthHeader = () => {
    const token = localStorage.getItem('token');
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
};

export const get = async (endpoint, params = {}) => {
    setAuthHeader();
    const response = await axios.get(endpoint, { params });
    return response.data;
};

export const post = async (endpoint, data = {}) => {
    setAuthHeader();
    const response = await axios.post(endpoint, data);
    return response.data;
};

export const put = async (endpoint, data = {}) => {
    setAuthHeader();
    const response = await axios.put(endpoint, data);
    return response.data;
};

export const del = async (endpoint, data = {}) => {
    setAuthHeader();
    const response = await axios.delete(endpoint, { data });
    return response.data;
};